import React from 'react';
import {
  Image, ScrollView, Text, TouchableOpacity, View,
} from 'react-native';
import { img_blue_down_arrow } from '../utils/ImagesManagementUtils';
import {
  Android, Both, services_category,
} from '../utils/DictionaryManagementUtils';
import Sim_V01_announcement from '../simulators/Sim_V01_announcement';
import Sim_V02_promotion from '../simulators/Sim_V02_promotion';
import Sim_V03_instructions from '../simulators/Sim_V03_instructions';
import Sim_T01_launch_keyboard from '../simulators/Sim_T01_launch_keyboard';
import Sim_T02_Auth from '../simulators/Sim_T02_Auth';
import Sim_T03_Launch_error_messages from '../simulators/Sim_T03_Launch_error_messages';
import Sim_T05_Launch_empty_state from '../simulators/Sim_T05_Launch_empty_state';
import Sim_T06_iMsgExpandTexts from '../simulators/Sim_T06_iMsgExpandTexts';
import Sim_A03_Menu from '../simulators/Sim_A03_Menu';
import Sim_B02_SendMoneyRecipientsList from '../simulators/Sim_B02_SendMoneyRecipientsList';
import Sim_B02_SendMoneySearchResults from '../simulators/Sim_B02_SendMoneySearchResults';
import Sim_B03_SendMoneyTransferMethod from '../simulators/Sim_B03_SendMoneyTransferMethod';
import Sim_B04_SendMoneyToCreditManually from '../simulators/Sim_B04_SendMoneyToCreditManually';
import Sim_B05_SendMoneyToPhoneManually from '../simulators/Sim_B05_SendMoneyToPhoneManually';
import Sim_B06_SendMoneyToAccountManually from '../simulators/Sim_B06_SendMoneyToAccountManually';
import Sim_B07_SendMoneyToIBANManually from '../simulators/Sim_B07_SendMoneyToIBANManually';
import Sim_B07_SendMoneyToCustomerIDManually from '../simulators/Sim_B07_SendMoneyToCustomerIDManually';
import Sim_B07a_SendMoneyToCpfManually from '../simulators/Sim_B07a_SendMoneyToCpfManually';
import Sim_B07b_SendMoneyToEmailManually from '../simulators/Sim_B07b_SendMoneyToEmailManually';
import Sim_B07c_SendMoneyToEvpManually from '../simulators/Sim_B07c_SendMoneyToEvpManually';
import Sim_B08_SendMoneyEnterAmount from '../simulators/Sim_B08_SendMoneyEnterAmount';
import Sim_B08_SendMoneyPayingAccount from '../simulators/Sim_B08_SendMoneyPayingAccount';
import Sim_B09_SendMoneyReference from '../simulators/Sim_B09_SendMoneyReference';
import Sim_B10_SendMoneyConfirmation from '../simulators/Sim_B10_SendMoneyConfirmation';
import Sim_B12_SendMoneySuccess from '../simulators/Sim_B12_SendMoneySuccess';
import Sim_C02_AccountInfoBalance from '../simulators/Sim_C02_AccountInfoBalance';
import Sim_C03_AccountInfoInOut from '../simulators/Sim_C03_AccountInfoInOut';
import Sim_D01_PayBillsBillsList from '../simulators/Sim_D01_PayBillsBillsList';
import Sim_D01_PayBillsPayingAccount from '../simulators/Sim_D01_PayBillsPayingAccount';
import Sim_D02_PayBillsEnterCode from '../simulators/Sim_D02_PayBillsEnterCode';
import Sim_D04_PayBillsConfirmation from '../simulators/Sim_D04_PayBillsConfirmation';
import Sim_D06_PayBillsSuccess from '../simulators/Sim_D06_PayBillsSuccess';
import Sim_F02_RequestPaymentRecipientsList from '../simulators/Sim_F02_RequestPaymentRecipientsList';
import Sim_F02_RequestPaymentSearchResults from '../simulators/Sim_F02_RequestPaymentSearchResults';
import Sim_F03_RequestPaymentTransferMethod from '../simulators/Sim_F03_RequestPaymentTransferMethod';
import Sim_F04_RequestPaymentToCreditManually from '../simulators/Sim_F04_RequestPaymentToCreditManually';
import Sim_F05_RequestPaymentToPhoneManually from '../simulators/Sim_F05_RequestPaymentToPhoneManually';
import Sim_F06_RequestPaymentToAccountManually from '../simulators/Sim_F06_RequestPaymentToAccountManually';
import Sim_F07_RequestPaymentToCustomerIDManually from '../simulators/Sim_F07_RequestPaymentToCustomerIDManually';
import Sim_F07_RequestPaymentToIBANManually from '../simulators/Sim_F07_RequestPaymentToIBANManually';
import Sim_F07a_RequestPaymentToCpfManually from '../simulators/Sim_F07a_RequestPaymentToCpfManually';
import Sim_F07b_RequestPaymentToEmailManually from '../simulators/Sim_F07b_RequestPaymentToEmailManually';
import Sim_F07c_RequestPaymentToEvpManually from '../simulators/Sim_F07c_RequestPaymentToEvpManually';
import Sim_F08_RequestPaymentEnterAmount from '../simulators/Sim_F08_RequestPaymentEnterAmount';
import Sim_F08_RequestPaymentPayingAccount from '../simulators/Sim_F08_RequestPaymentPayingAccount';
import Sim_F09_RequestPaymentReference from '../simulators/Sim_F09_RequestPaymentReference';
import Sim_F10_RequestPaymentConfirmation from '../simulators/Sim_F10_RequestPaymentConfirmation';
import Sim_F12_RequestPaymentSuccess from '../simulators/Sim_F12_RequestPaymentSuccess';
import Sim_G02_SplitPaymentRecipientsList from '../simulators/Sim_G02_SplitPaymentRecipientsList';
import Sim_G02_SplitPaymentConfirmParticipant from '../simulators/Sim_G02_SplitPaymentConfirmParticipant';
import Sim_G02_SplitPaymentSearchResults from '../simulators/Sim_G02_SplitPaymentSearchResults';
import Sim_G03_SplitPaymentTransferMethod from '../simulators/Sim_G03_SplitPaymentTransferMethod';
import Sim_G04_SplitPaymentToCreditManually from '../simulators/Sim_G04_SplitPaymentToCreditManually';
import Sim_G05_SplitPaymentToPhoneManually from '../simulators/Sim_G05_SplitPaymentToPhoneManually';
import Sim_G06_SplitPaymentToAccountManually from '../simulators/Sim_G06_SplitPaymentToAccountManually';
import Sim_G07_SplitPaymentToCustomerIDManually from '../simulators/Sim_G07_SplitPaymentToCustomerIDManually';
import Sim_G07_SplitPaymentToIBANManually from '../simulators/Sim_G07_SplitPaymentToIBANManually';
import Sim_G07a_SplitPaymentToCpfManually from '../simulators/Sim_G07a_SplitPaymentToCpfManually';
import Sim_G07b_SplitPaymentToEmailManually from '../simulators/Sim_G07b_SplitPaymentToEmailManually';
import Sim_G07c_SplitPaymentToEvpManually from '../simulators/Sim_G07c_SplitPaymentToEvpManually';
import Sim_G08_SplitPaymentEnterAmount from '../simulators/Sim_G08_SplitPaymentEnterAmount';
import Sim_G08_SplitPaymentPayingAccount from '../simulators/Sim_G08_SplitPaymentPayingAccount';
import Sim_G09_SplitPaymentReference from '../simulators/Sim_G09_SplitPaymentReference';
import Sim_G10_SplitPaymentConfirmation from '../simulators/Sim_G10_SplitPaymentConfirmation';
import Sim_G12_SplitPaymentSuccess from '../simulators/Sim_G12_SplitPaymentSuccess';
import Sim_H08_TopUpSelectOperator from '../simulators/Sim_H08_TopUpSelectOperator';
import Sim_H08_TopUpSelectPackage from '../simulators/Sim_H08_TopUpSelectPackage';
import Sim_H08_TopUpPayingAccount from '../simulators/Sim_H08_TopUpPayingAccount';
import Sim_X01_themeColors from '../simulators/Sim_X01_themeColors';
import Sim_X01_themeRadius from '../simulators/Sim_X01_themeRadius';
import Sim_X02_themeFonts from '../simulators/Sim_X02_themeFonts';
import Sim_Z02_development_configurations from '../simulators/Sim_Z02_development_configurations';
import Sim_D01_PayBillsChooseMethod from '../simulators/Sim_D01_PayBillsChooseMethod';
import Sim_Y02_keyboardPromotion from '../simulators/Sim_Y02_keyboardPromotion';
import Sim_J01_LoanUpdateAmount from '../simulators/Sim_J01_LoanUpdateAmount';
import Sim_J02_LoanNumberInstallments from '../simulators/Sim_J02_LoanNumberInstallments';
import Sim_J03_LoanSelectSource from '../simulators/Sim_J03_LoanSelectSource';
import Sim_J04_LoanInstallmentOptions from '../simulators/Sim_J04_LoanInstallmentOptions';
import Sim_J05_LoanConfirmation from '../simulators/Sim_J05_LoanConfirmation';
import Sim_J06_LoanSuccess from '../simulators/Sim_J06_LoanSuccess';

//= ========================================================================
const SimulatorViewer = ({
  globJSON,
  slideshowJSON,
  selectedScreen,
  screenHeight,
  deviceType,
  onConfigChanged,
  setDeviceType,
  iMsgSimulatorState,
  bothSimulatorState,
  handlePlatformSelected,
  language,
  arrSnapshotRefs,
  slideshowState,
  isSlideshowOn,
  showPlatformSelector,
  showSlideshowButton,
  slideshowRefs,
  stopSlideshow,
  startSlideshow,
  downloadSlideshow,
}) => {
  const myStyles = {
    simulatorScrollbar: {
      height: screenHeight - 60,
      backgroundColor: '#f0f5f9',
    },
    simulatorWindow: {
      backgroundColor: '#f0f5f9',
      paddingStart: '15%',
      paddingVertical: 50,
      height: screenHeight,
    },

  };

  const renderSlideshowAllViews = () => {
    let screenIndex = 0;

    return slideshowJSON.screens.map((item, index) => {
      slideshowJSON.screens[index].screen_index = screenIndex;
      screenIndex += 1;
      const key_screen = `${item.screen_name}_${index}`;
      return (
        <View style={myStyles.simulatorWindow} key={key_screen}>
          {renderSimulatorSingleView(index, true)}
        </View>
      );
    });
  };

  const renderSimulatorSingleView = (index, isSlideshow = false) => {
    let theJSON;

    if (isSlideshow) {
      theJSON = slideshowJSON;
    } else {
      theJSON = globJSON;
    }

    const name = theJSON.screens[index].screen_name;

    return (

      <View style={myStyles.simulatorWindow} nativeID={name}>
        {!showPlatformSelector() ? null : (
          <View
            style={{
              marginBottom: 50,
              zIndex: 2,
            }}
          >
            <TouchableOpacity
              style={{
                width: 95,
                height: 36,
                backgroundColor: '#fff',
                borderColor: '#008cff',
                borderRadius: 18,
                borderWidth: 2,
              }}
              onPress={() => {
                setDeviceType({ ...deviceType, isShowingMenu: true });
              }}
            >
              <Text
                style={{
                  width: 63,
                  height: 20,
                  marginLeft: 14,
                  marginTop: 7,
                  position: 'absolute',
                  fontFamily: 'Quicksand-SemiBold',
                  fontSize: 14,
                  textAlign: 'left',
                  color: '#6baaff',
                }}
              >
                {deviceType.selectedPlatform}
              </Text>
              <Image
                fadeDuration={0}
                style={{
                  width: 7,
                  height: 4,
                  marginLeft: 75,
                  marginTop: 14,
                  position: 'absolute',
                }}
                source={img_blue_down_arrow}
              />
            </TouchableOpacity>

            {deviceType.isShowingMenu ? (
              <View
                style={{
                  width: 95,
                  height: (iMsgSimulatorState || bothSimulatorState) ? 106 : 73,
                  marginLeft: 0,
                  marginTop: 0,
                  position: 'absolute',
                  backgroundColor: '#fff',
                  borderColor: '#008cff',
                  borderRadius: 18,
                  borderWidth: 2,
                }}
              >
                <TouchableOpacity
                  style={{ width: 95, height: 34, marginTop: 0 }}
                  onPress={() => {
                    handlePlatformSelected('iOS');
                  }}
                >
                  <Text
                    style={{
                      width: 63,
                      height: 20,
                      marginLeft: 14,
                      marginTop: 7,
                      position: 'absolute',
                      fontFamily: 'Quicksand-SemiBold',
                      fontSize: 14,
                      textAlign: 'left',
                      color: '#6baaff',
                    }}
                  >
                    iOS
                  </Text>
                </TouchableOpacity>
                <View
                  style={{
                    height: 1,
                    marginLeft: 5,
                    marginRight: 5,
                    backgroundColor: '#d9d9d9',
                  }}
                />
                <TouchableOpacity
                  style={{ width: 95, height: 34 }}
                  onPress={() => {
                    handlePlatformSelected(Android);
                  }}
                >
                  <Text
                    style={{
                      width: 63,
                      height: 20,
                      marginLeft: 14,
                      marginTop: 7,
                      position: 'absolute',
                      fontFamily: 'Quicksand-SemiBold',
                      fontSize: 14,
                      textAlign: 'left',
                      color: '#6baaff',
                    }}
                  >
                    Android
                  </Text>
                </TouchableOpacity>
                {bothSimulatorState && (
                <View>
                  <View
                    style={{
                      height: 1,
                      marginLeft: 5,
                      marginRight: 5,
                      backgroundColor: '#d9d9d9',
                    }}
                  />
                  <TouchableOpacity
                    style={{ width: 95, height: 34 }}
                    onPress={() => {
                      handlePlatformSelected(Both);
                    }}
                  >
                    <Text
                      style={{
                        width: 63,
                        height: 20,
                        marginLeft: 14,
                        marginTop: 7,
                        position: 'absolute',
                        fontFamily: 'Quicksand-SemiBold',
                        fontSize: 14,
                        textAlign: 'left',
                        color: '#6baaff',
                      }}
                    >
                      Both
                    </Text>
                  </TouchableOpacity>
                </View>
                )}
                {globJSON.configurations.deliverables.deliverables.iMsg_enabled && iMsgSimulatorState ? (
                  <>
                    <View
                      style={{
                        height: 1,
                        marginLeft: 5,
                        marginRight: 5,
                        backgroundColor: '#d9d9d9',
                      }}
                    />
                    <TouchableOpacity
                      style={{ width: 95, height: 34 }}
                      onPress={() => {
                        handlePlatformSelected('iMessage');
                      }}
                    >
                      <Text
                        style={{
                          width: 63,
                          height: 20,
                          marginLeft: 14,
                          marginTop: 7,
                          position: 'absolute',
                          fontFamily: 'Quicksand-SemiBold',
                          fontSize: 14,
                          textAlign: 'left',
                          color: '#6baaff',
                        }}
                      >
                        iMessage
                      </Text>
                    </TouchableOpacity>
                  </>
                ) : null}
              </View>
            ) : null}

            {showSlideshowButton(selectedScreen) ? (
              <TouchableOpacity
                style={{
                  width: 140,
                  height: 36,
                  marginLeft: 105,
                  marginTop: 0,
                  position: 'absolute',
                  backgroundColor: '#fff',
                  borderColor: '#008cff',
                  borderRadius: 18,
                  borderWidth: 2,
                }}
                onPress={() => {
                  if (isSlideshowOn) {
                    stopSlideshow();
                  } else {
                    startSlideshow();
                  }
                }}
              >
                <Text
                  style={{
                    height: 20,
                    width: 112,
                    marginLeft: 14,
                    marginTop: 7,
                    position: 'absolute',
                    fontFamily: 'Quicksand-SemiBold',
                    fontSize: 14,
                    textAlign: 'center',
                    color: '#6baaff',
                  }}
                >
                  {isSlideshowOn ? 'Stop slideshow' : 'Create Slidshow'}
                </Text>
              </TouchableOpacity>
            ) : null}

            {isSlideshowOn ? (
              <TouchableOpacity
                style={{
                  width: 100,
                  height: 36,
                  marginLeft: 104 + 140 + 10,
                  marginTop: 0,
                  position: 'absolute',
                  backgroundColor: '#fff',
                  borderColor: '#008cff',
                  borderRadius: 18,
                  borderWidth: 2,
                }}
                onPress={() => {
                  downloadSlideshow();
                }}
              >
                <Text
                  style={{
                    height: 20,
                    width: 100 - 28,
                    marginLeft: 14,
                    marginTop: 7,
                    position: 'absolute',
                    fontFamily: 'Quicksand-SemiBold',
                    fontSize: 14,
                    textAlign: 'center',
                    color: '#6baaff',
                  }}
                >
                  {slideshowState.idxImages !== 0
                    ? `${slideshowState.idxImages} / ${slideshowState.totImages}`
                    : 'Download'}
                </Text>
              </TouchableOpacity>
            ) : null}
          </View>
        )}
        {name === 'onboarding_announcement' ? (
          <Sim_V01_announcement
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'onboarding_promotion' ? (
          <Sim_V02_promotion
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'onboarding_instructions' ? (
          <Sim_V03_instructions
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}

        {name === 'launch_keyboard' ? (
          <Sim_T01_launch_keyboard
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'launch_auth' ? (
          <Sim_T02_Auth
            notSkipped
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'launch_error_messages' ? (
          <Sim_T03_Launch_error_messages
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'launch_empty_state' ? (
          <Sim_T05_Launch_empty_state
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'imsg_expand_texts' ? (
          <Sim_T06_iMsgExpandTexts
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'promotion' ? (
          <Sim_Y02_keyboardPromotion
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}

        {name === services_category ? (
          <Sim_A03_Menu
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}

        {name === 'send_money_recipients_list' ? (
          <Sim_B02_SendMoneyRecipientsList
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'send_money_search_results' ? (
          <Sim_B02_SendMoneySearchResults
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'send_money_transfer_method' ? (
          <Sim_B03_SendMoneyTransferMethod
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}

        {name === 'send_money_to_credit_card_manually' ? (
          <Sim_B04_SendMoneyToCreditManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'send_money_to_phone_manually' ? (
          <Sim_B05_SendMoneyToPhoneManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'send_money_to_account_manually' ? (
          <Sim_B06_SendMoneyToAccountManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'send_money_to_iban_manually' ? (
          <Sim_B07_SendMoneyToIBANManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'send_money_to_customer_id_manually' ? (
          <Sim_B07_SendMoneyToCustomerIDManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'send_money_to_cpf_cnpj_manually' ? (
          <Sim_B07a_SendMoneyToCpfManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'send_money_to_email_manually' ? (
          <Sim_B07b_SendMoneyToEmailManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'send_money_to_evp_manually' ? (
          <Sim_B07c_SendMoneyToEvpManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}

        {name === 'send_money_enter_amount' ? (
          <Sim_B08_SendMoneyEnterAmount
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'send_money_change_paying_account' ? (
          <Sim_B08_SendMoneyPayingAccount
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'send_money_reference' ? (
          <Sim_B09_SendMoneyReference
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'send_money_confirmation' ? (
          <Sim_B10_SendMoneyConfirmation
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'send_money_success' ? (
          <Sim_B12_SendMoneySuccess
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}

        {name === 'loan_amount' && (
          <Sim_J01_LoanUpdateAmount
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        )}

        {name === 'loan_installments_number' && (
          <Sim_J02_LoanNumberInstallments
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        )}

        {name === 'loan_source' && (
          <Sim_J03_LoanSelectSource
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        )}

        {name === 'loan_installments_option' && (
          <Sim_J04_LoanInstallmentOptions
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        )}

        {name === 'loan_confirmation' && (
          <Sim_J05_LoanConfirmation
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        )}

        {name === 'loan_success' && (
          <Sim_J06_LoanSuccess
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        )}

        {name === 'account_info_balance' ? (
          <Sim_C02_AccountInfoBalance
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'account_info_inout' ? (
          <Sim_C03_AccountInfoInOut
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}

        {name === 'pay_bills_bills_list' ? (
          <Sim_D01_PayBillsBillsList
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'pay_bills_choose_method' && (
          <Sim_D01_PayBillsChooseMethod
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        )}
        {name === 'pay_bills_Change_paying_account' ? (
          <Sim_D01_PayBillsPayingAccount
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'pay_bills_enter_code' ? (
          <Sim_D02_PayBillsEnterCode
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'pay_bills_confirmation' ? (
          <Sim_D04_PayBillsConfirmation
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'pay_bills_success' ? (
          <Sim_D06_PayBillsSuccess
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'request_payment_recipients_list' ? (
          <Sim_F02_RequestPaymentRecipientsList
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'request_payment_search_results' ? (
          <Sim_F02_RequestPaymentSearchResults
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'request_payment_transfer_method' ? (
          <Sim_F03_RequestPaymentTransferMethod
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'request_payment_to_credit_card_manually' ? (
          <Sim_F04_RequestPaymentToCreditManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'request_payment_to_phone_manually' ? (
          <Sim_F05_RequestPaymentToPhoneManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'request_payment_to_account_manually' ? (
          <Sim_F06_RequestPaymentToAccountManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'request_payment_to_customer_id_manually' ? (
          <Sim_F07_RequestPaymentToCustomerIDManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'request_payment_to_iban_manually' ? (
          <Sim_F07_RequestPaymentToIBANManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'request_payment_to_cpf_cnpj_manually' ? (
          <Sim_F07a_RequestPaymentToCpfManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'request_payment_to_email_manually' ? (
          <Sim_F07b_RequestPaymentToEmailManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'request_payment_to_evp_manually' ? (
          <Sim_F07c_RequestPaymentToEvpManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'request_payment_enter_amount' ? (
          <Sim_F08_RequestPaymentEnterAmount
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'request_payment_change_paying_account' ? (
          <Sim_F08_RequestPaymentPayingAccount
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'request_payment_reference' ? (
          <Sim_F09_RequestPaymentReference
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'request_payment_confirmation' ? (
          <Sim_F10_RequestPaymentConfirmation
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'request_payment_success' ? (
          <Sim_F12_RequestPaymentSuccess
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}

        {name === 'split_payment_recipients_list' ? (
          <Sim_G02_SplitPaymentRecipientsList
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'split_payment_confirm_participant' ? (
          <Sim_G02_SplitPaymentConfirmParticipant
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'split_payment_search_results' ? (
          <Sim_G02_SplitPaymentSearchResults
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'split_payment_transfer_method' ? (
          <Sim_G03_SplitPaymentTransferMethod
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'split_payment_to_credit_card_manually' ? (
          <Sim_G04_SplitPaymentToCreditManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'split_payment_to_phone_manually' ? (
          <Sim_G05_SplitPaymentToPhoneManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'split_payment_to_account_manually' ? (
          <Sim_G06_SplitPaymentToAccountManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'split_payment_to_customer_id_manually' ? (
          <Sim_G07_SplitPaymentToCustomerIDManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'split_payment_to_iban_manually' ? (
          <Sim_G07_SplitPaymentToIBANManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'split_payment_to_cpf_cnpj_manually' ? (
          <Sim_G07a_SplitPaymentToCpfManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'split_payment_to_email_manually' ? (
          <Sim_G07b_SplitPaymentToEmailManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'split_payment_to_evp_manually' ? (
          <Sim_G07c_SplitPaymentToEvpManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'split_payment_enter_amount' ? (
          <Sim_G08_SplitPaymentEnterAmount
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'split_payment_change_paying_account' ? (
          <Sim_G08_SplitPaymentPayingAccount
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'split_payment_reference' ? (
          <Sim_G09_SplitPaymentReference
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'split_payment_confirmation' ? (
          <Sim_G10_SplitPaymentConfirmation
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'split_payment_success' ? (
          <Sim_G12_SplitPaymentSuccess
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}

        {name === 'top_up_recipients_list' ? (
          <Sim_B02_SendMoneyRecipientsList
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'top_up_search_results' ? (
          <Sim_B02_SendMoneySearchResults
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'top_up_transfer_method' ? (
          <Sim_B03_SendMoneyTransferMethod
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}

        {name === 'top_up_to_credit_card_manually' ? (
          <Sim_B04_SendMoneyToCreditManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'top_up_to_phone_manually' ? (
          <Sim_B05_SendMoneyToPhoneManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'top_up_to_account_manually' ? (
          <Sim_B06_SendMoneyToAccountManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'top_up_to_iban_manually' ? (
          <Sim_B07_SendMoneyToIBANManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'top_up_to_customer_id_manually' ? (
          <Sim_B07_SendMoneyToCustomerIDManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'top_up_to_cpf_cnpj_manually' ? (
          <Sim_B07a_SendMoneyToCpfManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'top_up_to_email_manually' ? (
          <Sim_B07b_SendMoneyToEmailManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'top_up_to_evp_manually' ? (
          <Sim_B07c_SendMoneyToEvpManually
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}

        {name === 'top_up_select_operator' ? (
          <Sim_H08_TopUpSelectOperator
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'top_up_select_package' ? (
          <Sim_H08_TopUpSelectPackage
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'top_up_change_paying_account' ? (
          <Sim_H08_TopUpPayingAccount
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'top_up_reference' ? (
          <Sim_B09_SendMoneyReference
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'top_up_confirmation' ? (
          <Sim_B10_SendMoneyConfirmation
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'top_up_success' ? (
          <Sim_B12_SendMoneySuccess
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}

        {name === 'theme_colors' ? (
          <Sim_X01_themeColors
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'theme_radius' ? (
          <Sim_X01_themeRadius
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'theme_fonts' ? (
          <Sim_X02_themeFonts
            globJSON={theJSON}
            simPlatform={deviceType.selectedPlatform}
            selectedScreen={index}
            onConfigChanged={() => {
              onConfigChanged();
            }}
            language={language}
            slideshowRefs={isSlideshowOn ? slideshowRefs : null}
          />
        ) : null}
        {name === 'send_form' ? (
          <Sim_Z02_development_configurations
            globJSON={theJSON}
            arrSnapshotRefs={arrSnapshotRefs}
            hideDisplay

          />
        ) : null}
        {name === 'development_configurations' ? (
          <Sim_Z02_development_configurations
            globJSON={theJSON}
            arrSnapshotRefs={arrSnapshotRefs}
          />
        ) : null}
      </View>
    );
  };

  return (
    <ScrollView
      style={myStyles.simulatorScrollbar}
      vertical
      pagingEnabled={false}
      showsVerticalScrollIndicator={false}
      scrollEnabled
    >
      {isSlideshowOn ? renderSlideshowAllViews() : renderSimulatorSingleView(selectedScreen, false)}
    </ScrollView>
  );
};

export default SimulatorViewer;
